import React, {useEffect, useState} from "react";
import "./TeacherAdminPage.sass"
import Window from "../../../_containers/window/Window";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {getTeachers, removeTeacher} from "../../../_actions/auth/authAdminService";
import {IDLE, LOADING} from "../../../common/statuses";
import Spinner from "../../common/anonymous/Spinner";
import {Paper, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {StyledTableCell, StyledTableRow} from "../../../_components/TableComponents";
import TableBody from "@mui/material/TableBody";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DialogComponent from "../../../_components/common/dialog/DialogComponent";

export default function TeacherAdminPage() {

    const [showRemoveMessage, setShowRemoveMessage] = useState(null);
    const [showLastRemoveMessage, setShowLastRemoveMessage] = useState(null);

    const {data: teachers, status} = useSelector(state => state.auth.getTeachers);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getTeachers());
        }
    }, [status, dispatch])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    const handleRemove = (id) => {
        setShowRemoveMessage(id)
    }

    const renderTeacherItem = (teacher) => {
        const {id, username, firstName, lastName, middleName, groupsNumber, studentsNumber} = teacher
        return (
            <StyledTableRow key={`teacher-${id}`}>
                <StyledTableCell>{id}</StyledTableCell>
                <StyledTableCell>{lastName} {firstName} {middleName || ""}</StyledTableCell>
                <StyledTableCell>{username}</StyledTableCell>
                <StyledTableCell>{groupsNumber}</StyledTableCell>
                <StyledTableCell>{studentsNumber}</StyledTableCell>
                <StyledTableCell>
                    <CircleButton Icon={DeleteOutlineIcon} onClick={() => handleRemove(id)}/>
                </StyledTableCell>
            </StyledTableRow>
        )
    }

    const renderRemoveMessage = () => {
        return <DialogComponent title="Предупреждение об удалении"
                                buttons={{
                                    accept: "Далее",
                                    cancel: "Отменить",
                                }}
                                onClose={() => setShowRemoveMessage(null)}
                                open={showRemoveMessage}
                                onAccept={() => {
                                    setShowRemoveMessage(null);
                                    setShowLastRemoveMessage(showRemoveMessage);
                                }}>
            <div>
                Дальнейшие действия повлекут за собой полное удаление всех объектов, которые связаны с этим учителем.
            </div>
            <div>
                Восстановить данные после удаления будет невозможно.
            </div>
        </DialogComponent>
    }

    const renderLastRemoveMessage = () => {
        return <DialogComponent title="Вы действительно хотите удалить учителя?"
                                buttons={{
                                    accept: "Удалить",
                                    cancel: "Отменить",
                                }}
                                onClose={() => setShowLastRemoveMessage(null)}
                                open={showLastRemoveMessage}
                                onAccept={() => {
                                    dispatch(removeTeacher(showLastRemoveMessage))
                                    setShowLastRemoveMessage(null);
                                }}>
            <div>
                После нажатия на кнопку Удалить, будет запущен процесс удаления пользователя.
            </div>
            <div>
                Восстановить данные после удаления будет невозможно.
            </div>
        </DialogComponent>
    }

    return <Window>
        <div className="TeacherAdminPage-title">
            <div className="TeacherAdminPage-title-text">Список учителей</div>
            <CircleButton onClick={() => navigate(-1)} Icon={CloseIcon}/>
        </div>
        <div className="TeacherAdminPage-grid">
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>ФИО</StyledTableCell>
                            <StyledTableCell>Email</StyledTableCell>
                            <StyledTableCell>Групп</StyledTableCell>
                            <StyledTableCell>Учеников</StyledTableCell>
                            <StyledTableCell></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {teachers.map(renderTeacherItem)}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        {showRemoveMessage && renderRemoveMessage()}
        {showLastRemoveMessage && renderLastRemoveMessage()}
    </Window>
}